export default __webpack_public_path__ + "static/media/later-f.5f02c37b.svg";